import { StrategyBaseClass } from './strategy-base-class.js'


export class LinkedinService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 18;
  }
  getTypeString() {
    return 'linkedin';
  }
  getAllTasksTypes() {
    return [46];
  }
  getPrivateTaskTypes() {
    return [];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      46: 'linkedin/comments'
    };
    return mapping[taskType];
  }
  getTaskTypeQueueId(taskType) {
    let mapping = {
      46: 'linkedin-comments'
    };
    return mapping[taskType];
  }

  canHaveSurveys() {
    return false;
  }

  getEditorConfiguration(isPrivate) {
    const config = {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
      'videoEnabled': false,
      'fileEnabled': false
    };
    return config;
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 5,
      answerLabelMaxLength: 28,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: false
    };
  }

  static LinkedinFactory($translate) {
    return new LinkedinService($translate);
  }
}
LinkedinService.LinkedinFactory.$inject = ['$translate'];
